class BaoProductAccordion extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.els.trigger.element, 'click', this.scrollIntoView.bind(this))
  }

  scrollIntoView() {
    const triggerEl = this.els.trigger.element

    if (triggerEl.open) return
    if (window.innerWidth < 991) return

    window.scroll({
      top: window.innerHeight / 2,
      behavior: 'smooth',
    })
  }
}

if (!customElements.get('bao-product-accordion')) {
  customElements.define('bao-product-accordion', BaoProductAccordion)
}
